import React, { useState } from "react";
import "../Styles/style.css"


const OrderForm = (props: any) => {

  const { salesOrderRef } = props;

  let orderItem = salesOrderRef.getSelectedRows()
  console.log("orderItem",orderItem)
  let orderBy=[]
  let date=[]
  let route=[]
  let total=0

  for(let i=0;i<orderItem.length;i++){ 
 orderBy=[...orderBy,orderItem[i].customerName+","] 
  date=[...date,orderItem[i].orderDate+","] 
  route=[...route,orderItem[i].routeName+","] 
total+=Number(Number((orderItem[i].total)).toFixed(2))
}

 const salesMan = orderBy.filter((val, id) => { 
 return orderBy.indexOf(val) == id;  // this just returns unique salesman
});
const orderDate = date.filter((val, id) => { 
    return date.indexOf(val) == id;  // this just returns unique date
   });
   const routeName = route.filter((val, id) => { 
    return route.indexOf(val) == id;  // this just returns unique route
   });
//   // const [total, setTotal] = useState<any>("");
//   let cgst = 0;
//   let sgst = 0;
//   let qty=0
//   let rate=0
//   let totalAmt=0
//   for(let i=0;i<selectedRow.items.length;i++){
//     qty+=selectedRow.items[i].soldSku
//     rate+=selectedRow.items[i].price
// cgst+=Number(selectedRow.items[i].itemcgstAmount)
// sgst+=Number(selectedRow.items[i].itemsgstAmount)
// totalAmt+=Number(selectedRow.items[i].orderItemTotal)
//   }


  
const generateTable = () => {
    const orderItem = salesOrderRef.getSelectedRows();
    console.log("orderItem", orderItem);
    const table = [];
    let product=[]
    //let Total = 0;
    for (let i = 0; i < orderItem.length; i++) {
      orderItem[i]["slNo"] = i + 1;
    
      console.log("Product",product)
      const row = [];
let cell=[]
      for(let j=0;j<orderItem[i].items.length;j++){
        orderItem[i].items[j]["slNo"] = j + 1;
              
     cell = [...cell,
        <tr>
          <td align="center">{orderItem[i].items[j].slNo}</td>
          <td> {orderItem[i].items[j].productName}</td>
          <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
        </tr>
      ];}

      row.push(cell);
      table.push(row);
    }

    return table;
  };

  return (
    <div id="salesInvoiceBill">
    <div className="mainBody">
    <table className="border" width="100%">
            <tr>
                <td colSpan={17} align="center" className=" headingFont">
                    Order Form
                </td>
            </tr>
            <tr>
                <td colSpan={2} align="left" className="font600" width="20%">
                    Party :
                </td>
                <td colSpan={15} className="padding">
               {orderItem[0].shopName}
                </td>
            </tr>
            <tr>
                <td colSpan={2} align="left" className="font600">
                    Order By :
                </td>
                <td colSpan={15} className="padding">
              {salesMan}
                </td>
            </tr>
            <tr>
                <td colSpan={2} align="left" className="font600">
                    Order No. :
                </td>
                <td colSpan={15} className="padding">
                {orderItem[0].orderNumber}
                </td>
            </tr>
            <tr>
                <td colSpan={2} align="left" className="font600">
                    Date. :
                </td>
                <td colSpan={15} className="padding">
               {orderDate}
                </td>
            </tr>
            <tr>
                <td colSpan={2} align="left" className="font600">
                    Route Name. :
                </td>
                <td colSpan={15} className="padding">
                {routeName}   </td>
            </tr>
            <tr>
                <td colSpan={2} align="left" className="font600">
                    Total Amt. :
                </td>
                <td colSpan={15} className="padding">
                   {total} </td>
            </tr>
           
            <tr>
                <td className="font600" align="center" rowSpan={2} width="5%">Sr No.</td>
                <td className="font600" align="center" rowSpan={2}> Product Name</td>
                <td className="font600" align="center" colSpan={3}>5RS</td>
                <td className="font600" align="center" colSpan={3}>10RS</td>
                <td className="font600" align="center" colSpan={3}>60GM / 100GM /120GM</td>
                <td className="font600" align="center" colSpan={3}>200GM / 250GM /300GM</td>
                <td className="font600" align="center" colSpan={3}>400GM / 500GM </td>

            </tr>
            <tr>
                <td  className="font600 transform" height={50} align="center">
                    ALL
                </td>
                <td className="font600 transform" align="center" >
                    STRIP
                </td>
                <td className="font600 transform" align="center">
                    CRTN
                </td>
                <td className="font600 transform" align="center">
                    ALL
                </td>
                <td className="font600 transform" align="center">
                    STRIP
                </td>
                <td className="font600 transform" align="center">
                    CRTN
                </td>
                <td className="font600 transform" align="center">
                    ALL
                </td>
                <td className="font600 transform" align="center" >
                    STRIP
                </td>
                <td className="font600 transform" align="center">
                    CRTN
                </td>
                <td className="font600 transform" align="center">
                    ALL
                </td>
                <td className="font600 transform" align="center">
                    STRIP
                </td>
                <td className="font600 transform" align="center">
                    CRTN
                </td>
                <td className="font600 transform" align="center">
                    ALL
                </td>
                <td className="font600 transform" align="center">
                    STRIP
                </td>
                <td className="font600 transform" align="center">
                    CRTN
                </td>
            </tr>
            <tbody>{generateTable()}</tbody>
            <tr>
                <td></td>
                <td className="font600 " align="center">Total</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </table>

</div>
 </div>
  );
};

export default OrderForm;
